/*
INSTRUCTIONS

1. image must be stored in public/assets folder
2. image path must be /assets/<image-path>
3. provide full url in certLink

*/

export const certifications = [
	{
		id: 1,
		badgeImagePath: "/assets/aws-sa.png",
		certName: "AWS Solutions Architect",
		certLink:
			"https://cp.certmetrics.com/amazon/en/public/verify/credential/1ba5f957abf94d87bb2f2b0216da9979",
	},
	{
		id: 2,
		badgeImagePath: "/assets/lindner-da.png",
		certName: "Data Analytics - Graduate Certificate",
		certLink:
			"",
	},
	{
		id: 3,
		badgeImagePath: "https://www.redhat.com/cms/managed-files/certification-icon.png",
		certName: "Linux - Basic to Advance (Udemy)",
		certLink:
			"https://udemy-certificate.s3.amazonaws.com/image/UC-e1ef8bb9-0cfa-42da-a0e1-25fe9522497a.jpg",
	},
];
